<template>
  <p class="comment__item__author">
    <a
      class="comment__item__author__link"
      :href="(author.profile.vanity)
        ? `/u/${author.profile.vanity}`
        : null
      "
    >
      <span
        class="comment__item__author__picture"
        :style="backgroundProfileImageStyle"
      />
      <span
        class="comment__item__author__name"
      >{{ authorName }}</span>
    </a>
    <span class="bullet">&bull;</span>
    <span class="comment__item__meta">{{ comment.created_at | processDate }}</span>
  </p>
</template>

<script>
import moment from 'moment';
import User from '@/scripts/libs/login/User';

export default {
  filters: {
    processDate(dateString) {
      return moment(dateString).fromNow();
    },
  },
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    author() {
      return User.getProcessedResponse(this.comment.user);
    },
    authorName() {
      if (this.author.profile.firstName || this.author.profile.lastName) {
        return this.author.profile.firstName + ' ' + this.author.profile.lastName;
      }
      return 'Commenter';
    },
    backgroundProfileImageStyle() {
      return {
        backgroundImage: `url(${this.author.profile.profileImage()})`,
      };
    },
  },
  methods: {
  },
};
</script>

<style lang="scss">
.comment__item__author {
  margin-bottom: 4px;
}

.comment__item__author__link {
  background-color: transparent;
  border-radius: 99em;

  padding: 10px;
  padding-bottom: 12px;
  padding-top: 8px;
  margin: -10px;
  margin-bottom: 8px;

  transition: background-color 0.25s,
              box-shadow 0.25s;
  position: relative;

  .comment__item__author__name {
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.5);
  }
}

.comment__item__author__link[href] {
  cursor: pointer;
  .comment__item__author__name {
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
  }
}

// TODO: This is the same / similar with director block, consider creating a global class / module for this
.comment__item__author__link[href]:hover {
  .comment__item__author__name {
    color: black;
  }
}
.comment__item__author__link[href]:active {
  transform: translateY(1px);
}
</style>
